import { Select } from "@mantine/core";

type IPriceListReportTypeSelectProps = {
  value: number;
  name: string;
  label: string;
  title?: string;
  setValue: (val: number) => void;
};
const reportTypeOptions = [
  { value: "0", label: "Product Profilt Margin (Month)" },
  { value: "1", label: "Product Profit Margin (Year to Date)" },
];
const SalesMarginReportTypeSelection = ({
  value,
  label,
  title,
  name,
  setValue,
  ...rest
}: IPriceListReportTypeSelectProps) => {
  return (
    <Select
      name={name}
      key={name}
      label={label}
      w={300}
      data={reportTypeOptions}
      value={value.toString()}
      onChange={(val) => {
        const parsed = parseInt(val ?? "0", 10);
        setValue(parsed);
      }}
      allowDeselect={false}
      comboboxProps={{
        withinPortal: true,
        zIndex: 3001,
      }}
      clearable
    />
  );
};

export default SalesMarginReportTypeSelection;
